import React, { useState, useRef, useEffect } from 'react';
import logo from '../images/OLI-logo-white.svg';

const TitleBar = () => {
  const [showPopup, setShowPopup] = useState(false);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleUserMenuClick = () => {
    setShowPopup(!showPopup);
  };

  return (
    <div className="title-bar">
      <div className="title-bar-left">
        <div className="title-bar-logo">
          <img src={logo} alt="OLI Logo" />
          <span className="title-bar-text">OLI Cloud</span>
        </div>
      </div>
      <div className="title-bar-right" ref={userMenuRef}>
        <div className="user-menu" onClick={handleUserMenuClick}>
          <span className="user-name">User Name</span>
          <i className="fas fa-user-circle user-avatar" aria-hidden="true"></i>
        </div>
        <div className={`user-popup ${showPopup ? 'show' : ''}`}>
          <a href="#settings" className="user-popup-item">
            <i className="fas fa-cog" style={{ marginRight: '0.5rem' }}></i>
            User Settings
          </a>
          <a href="#signout" className="user-popup-item">
            <i className="fas fa-sign-out-alt" style={{ marginRight: '0.5rem' }}></i>
            Sign Out
          </a>
        </div>
      </div>
    </div>
  );
};

export default TitleBar; 